export default [
    {
    path: '',
    redirect: { name: 'AdmHome' },
  },
  {
    name: 'AdmHome',
    path: 'dashboard',
    component: () => import('@/views/admin/AdmDashboard.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "dashboard",
    },
  },
  {
    name: 'AdmProfile',
    path: 'profile',
    component: () => import('@/views/admin/ProfileView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "profile",
    },
  },
  {
    name: 'AppMagazine',
    path: 'e-magazine/:id?',
    component: () => import('@/views/admin/AppMagazine/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "e-magazine",
    },
  },
  {
    name: 'SLSCustomerManagement',
    path: 'customers/:slug?/:id?',
    component: () => import('@/views/admin/SLSCustomerManagement/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "customers",
    },
  },
  {
    name: 'CustPosition',
    path: 'customers-position/:slug?/:id?',
    component: () => import('@/views/admin/MCustPosition/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "customers-position",
    },
  },
  {
    name: 'SLSSalesManagement',
    path: 'sales/:slug?/:id?',
    component: () => import('@/views/admin/SLSSalesManagement/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "sales",
    },
  },
  {
    name: 'SLSProductManagement',
    path: 'products/:slug?/:id?',
    component: () => import('@/views/admin/SLSProductManagement/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "products",
    },
  },
  {
    name: 'SLSPurchaseOrder',
    path: 'purchase-orders/:slug?/:id?',
    component: () => import('@/views/admin/SLSPurchaseOrder/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "purchase-orders",
    },
  },
  {
    name: 'KondisiUntukPelanggan',
    path: 'kup/:slug?/:id?',
    component: () => import('@/views/admin/KondisiUntukPelanggan/IndexView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "kup",
    },
  },
  {
    name: 'SignerKondisiUntukPelanggan',
    path: 'kup-signer/:slug?/:id?',
    component: () => import('@/views/admin/KondisiUntukPelanggan/SignerConfig.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "kup-signer",
    },
  },
  // {
  //   name: 'PerjanjianJualBeli',
  //   path: 'pjb/:slug?/:id?',
  //   component: () => import('@/views/admin/PerjanjianJualBeli/IndexView.vue'),
  //   meta: {
  //     requiresAuth: true,
  //     apiPath: "pjb",
  //   },
  // },
  {
    name: 'Reporting',
    path: 'reporting/:slug?',
    component: () => import('@/views/admin/Reporting/IndexView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "reporting",
    },
  },
  {
    name: 'SLSProductManagement',
    path: 'products/:slug?/:id?',
    component: () => import('@/views/admin/SLSProductManagement/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "products",
    },
  },

  {
    name: 'MTemplateSurat',
    path: 'master-template-surat/:id?',
    component: () => import('@/views/admin/MTemplateSurat/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "master-templates",
    },
  },
  {
    name: 'MStaticContent',
    path: 'static-content/:id?',
    component: () => import('@/views/admin/MStaticContent/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "static-content",
    },
  },
  {
    name: 'MProductsCategory',
    path: 'master-products-category/:id?',
    component: () => import('@/views/admin/MProductsCategory/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "master-products-category",
    },
  },
  {
    name: 'MTransportation',
    path: 'master-transportasi/:id?',
    component: () => import('@/views/admin/MTransportation/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "master-transportation",
    },
  },
  {
    name: 'MBankInfo',
    path: 'bank-info/:id?',
    component: () => import('@/views/admin/MBankInfo/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "master-bank-info",
    },
  },
  {
    name: 'TempoBayar',
    path: 'tempo-bayar/:id?',
    component: () => import('@/views/admin/MTempoBayar/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "master-tempo-bayar",
    },
  },
  {
    name: 'MAreaCode',
    path: 'master-area-code/:id?',
    component: () => import('@/views/admin/MAreaCode/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "master-area-codes",
    },
  },
  {
    name: 'MNotification',
    path: 'master-notifikasi',
    component: () => import('@/views/admin/MNotification/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "master-notification",
    },
  },
  {
    name: 'AdmAppConfig',
    path: 'config-menu',
    component: () => import('@/views/admin/AdmAppSettings/AppConfig.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "config-menus",
    },
  },

  {
    name: 'AdmHolidayConfig',
    path: 'config-holiday',
    component: () => import('@/views/admin/AdmAppSettings/HolidayConfig.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "config-holidays",
    },
  },

  {
    name: 'AdmOperationalConfig',
    path: 'operational-hour',
    component: () => import('@/views/admin/AdmAppSettings/OperationalConfig.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "operational-hours",
    },
  },

  {
    name: 'AdmAuditrail',
    path: 'audit-trail',
    component: () => import('@/views/admin/AdmAuditrail/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "audit-trails",
    },
  },
  {
    name: 'AdmUser',
    path: 'backoffice-users/:id?',
    component: () => import('@/views/admin/AdmUser/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "bo-users",
    },
  },
  {
    name: 'AdmUserLevel',
    path: 'backoffice-user-level/:id?',
    component: () => import('@/views/admin/AdmUserLevel/ListView.vue'),
    requiresAuth: true,
    meta: {
      requiresAuth: true,
      apiPath: "bo-user-levels",
    },
  },
  {
    name: 'FoUser',
    path: 'internal-users/:id?',
    component: () => import('@/views/admin/FoUser/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "fo-users",
    },
  },
  {
    name: 'FoUserLevel',
    path: 'internal-user-level/:id?',
    component: () => import('@/views/admin/FoUserLevel/ListView.vue'),
    requiresAuth: true,
    meta: {
      requiresAuth: true,
      apiPath: "fo-user-levels",
    },
  },
  {
    name: 'AccountReceivable',
    path: 'account-receivable/:slug?/:id?',
    component: () => import('@/views/admin/AccountReceivable/IndexView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "account-receivables",
    },
  },
  {
    name: 'WABroadcastDashboard',
    path: 'wa-broadcast-dashboard',
    component: () => import('@/views/admin/WABroadcastDashboard/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "wa-broadcast-dashboard",
    },
  },
  {
    name: 'WABroadcastCampaign',
    path: 'wa-broadcast-campaign/:id?',
    component: () => import('@/views/admin/WABroadcastCampaign/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "wa-broadcast-campaign",
    },
  },
  {
    name: 'WABroadcastTemplate',
    path: 'wa-broadcast-template/:id?',
    component: () => import('@/views/admin/WABroadcastTemplate/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "wa-broadcast-template",
    },
  },
  {
    name: 'WABroadcastRecepient',
    path: 'wa-broadcast-recepient/:id?',
    component: () => import('@/views/admin/WABroadcastRecepient/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "wa-broadcast-recepient",
    },
  },
  {
    name: 'WABroadcastSender',
    path: 'wa-broadcast-sender/:id?',
    component: () => import('@/views/admin/WABroadcastSender/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "wa-broadcast-sender",
    },
  },
  {
    name: 'SLSHirarkiArea',
    path: 'hirarki-area/:id?',
    component: () => import('@/views/admin/SLSHirarkiArea/ListView.vue'),
    meta: {
      requiresAuth: true,
      apiPath: "hirarki-area",
    },
  },

  
  
]
